import { haveAnyValue, selectNonNullOrNonEmpty } from 'src/utils/utilitiesV2'
import { formatDateFromMillis } from 'src/utils/formatters'

export const formatBatchItem = (batch: string, expiredAt: number): string => {
  let response = `${selectNonNullOrNonEmpty(batch, '')}`
  if (haveAnyValue(expiredAt))
    response += `, Expira: ${formatDateFromMillis(expiredAt, null, true)}`

  return response
}
